/* NEWSLETTER */
$('body').on('click', '#mc-embedded-subscribe', function() {
  if ($('#agree-newsletter').is(':checked')) {
    $(this).submit();
  }else{
    alert("Debes aceptar la política de privacidad.");
    return false;
  }
});

$('body').on('click', '#mc-embedded-subscribe-footer', function() {
  if ($('#agree-newsletter-footer').is(':checked')) {
    $(this).submit();
  }else{
    alert("Debes aceptar la política de privacidad.");
    return false;
  }
});

$('body').on('click', '#newsletter-button', function() {
  if ($('#agree-newsletter').is(':checked')) {
    $(this).submit();
  }else{
    alert("Debes aceptar la política de privacidad.");
    return false;
  }
});

$('body').on('click', '#newsletter-footer-button', function() {
  if ($('#agree-newsletter-footer').is(':checked')) {
    $(this).submit();
  }else{
    alert("Debes aceptar la política de privacidad.");
    return false;
  }
});

/* REGISTER */
$('body').on('click', '#create-customer .btn', function() {
  if ($('#agree-newsletter-register').is(':checked')) {
    $(this).submit();
  }else{
    alert("Debes aceptar la política de privacidad.");
    return false;
  }
});

/* BLOG */
// S'ha comentat un codi a l'arxiu theme.js a la linia 5409 perquè pugui funcionar el següent codi custom.
$(document).ready(function() {
  $('.menu').hide();
  $('.link-dropdown__link').click(function(){
    $(this).next('.menu').slideDown(1000).siblings('.menu').slideUp(1000);
  });
});